import { Component, HostListener, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { State } from '../../../../models/state.model';
import { OnBoardingService } from '../../../../api-services/onboarding.service';
import { DocumentType } from '../../../../models/onboarding/document-type.model';
import { TenantConfig } from '../../../../models/onboarding/tenant-config.model';
import { OnboardingUser } from '../../../../models/onboarding/on-boarding-user.model';
import { UserFile } from '../../../../models/onboarding/user-file.model';
import { SharedService } from 'services';

@Component({
  selector: 'app-upload-document',
  templateUrl: './writing-code-document.component.html',
  styleUrls: ['./writing-code-document.component.css']
})
export class WritingCodeDocumentComponent implements OnInit {
  @Input() tenantFileConfig: boolean;
  selectedFiles: FileList | null = null;
  fileId = 0;
  @Input() newUploadedFiles: any  = [] as any[];
  newFile = {} as TenantConfig;

  fileUploadValid = true;
  @Input() showUploadWizard = true;
  errorMessages = [];
  errorMessagesFileFormat = [];
  states: State[] = [] as State[];
  documentTypes: DocumentType[];
  dropdownSettingState: IDropdownSettings;

  @Input() onboardingUser: OnboardingUser;
  @Input() checkList: any;
  @Input() onboardingUserDoc: boolean;
  @Input() newUserRequests: OnboardingUser[];

  constructor( public ss:SharedService, public activeModal: NgbActiveModal, private onboardingService: OnBoardingService) { }

  ngOnInit(): void {
    console.log("checkList", this.newUploadedFiles);
    var datatest=this.checkList;
    this.dropdownSettingState = {
      singleSelection: false,
      idField: 'stateCode',
      textField: 'stateName',
      selectAllText: 'Select All',
      unSelectAllText: 'Clear All',
      allowSearchFilter: true,
      itemsShowLimit: 4,
    };
this.getDocumentTypes();
  }



    getDocumentTypes() {
    this.onboardingService.getDocumentTypes().subscribe(response => {
      if (response) {
        this.documentTypes = response;
      }
    })
  }
  // Drag and drop
  @HostListener("dragover", ["$event"]) onDragOver(event: any) {
    event.preventDefault();
  }
  @HostListener("dragenter", ["$event"]) onDragEnter(event: any) {
    event.preventDefault();
  }
  @HostListener("dragend", ["$event"]) onDragEnd(event: any) {
    event.preventDefault();
  }
  @HostListener("dragleave", ["$event"]) onDragLeave(event: any) {
    event.preventDefault();
  }
  @HostListener("drop", ["$event"]) onDrop(event: any) {
    if (event.dataTransfer.files && event.target.classList.contains('drag-drop')) {
      event.preventDefault();
      event.stopPropagation();
      let files: FileList = event.dataTransfer.files;
      this.selectedFiles = files;
      this.getSelectedFiles();
      this.getValidFiles(); //event
        if(this.fileUploadValid)
    {
      this.insertUserFile()
    }else
    { 
      this.showUploadWizard = false;
    }
    }
  }

  close(): void {
    this.activeModal.close(true);
  }

  selectFiles(event) {
  const files = event.target.files;

      if (!files || files.length === 0) {
    return;
  }

    this.selectedFiles = event.target.files;
    this.getSelectedFiles();
    this.getValidFiles();
    if(this.fileUploadValid)
    {
      this.insertUserFile()
    }else
    { 
      this.showUploadWizard = false;
    }
  }

  private getValidFiles() {
    this.errorMessagesFileFormat = [];

    this.fileUploadValid = true;
    const supportedExt = "application/pdf, image/jpg, image/jpeg, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"

    for (let i = 0; i < this.newUploadedFiles.length; i++) {
      let file = this.newUploadedFiles[i].file;

      let ext = file.type;
      let size = file.size;

      //Hiding Quick Fill option for file types other than PDF
      this.newUploadedFiles[i].fileType = ext;
      if (this.newUploadedFiles[i].fileType != 'application/pdf') {
        this.newUploadedFiles[i].documentTypes = this.documentTypes.filter(qf => qf.documentTypeId != 1);
      } else {
        this.newUploadedFiles[i].documentTypes = this.documentTypes
      }


      if (supportedExt.includes(ext)) {
        if (size > 10485760) {
          this.fileUploadValid = false;
          this.newUploadedFiles[i].errorMessagesFileSize = "Invalid file size! Max file size 10Mb"
        }
      } else {
        this.fileUploadValid = false;
        this.newUploadedFiles[i].errorMessagesFileFormat = "Invalid file format! Allowed file format is .pdf, .doc, .docx, .jpg, .jpeg, and .xlsx"
      }
    }
  }

  getSelectedFiles() {
    for (let i = 0; i < this.selectedFiles.length; i++) {
      this.newFile = {
        file: this.selectedFiles[i],
        documentName: this.selectedFiles[i].name,
        documentSize: (this.selectedFiles[i].size / 1024 / 1024),
        documentTypeId: 3,
      } as TenantConfig;
      this.newUploadedFiles.push(this.newFile);
    }
  }

  deleteUploadFile(index) {
    if (index > -1 && index < this.newUploadedFiles.length) {
      this.newUploadedFiles.splice(index, 1);
    }

    if (this.newUploadedFiles.length == 0) {
      this.selectedFiles = null;
      this.fileUploadValid = true;
      this.showUploadWizard = true;
    } else {
      this.errorMessagesFileFormat = [];
      this.getValidFiles();
    }
  }

  insertTenantConfig() {
    if (this.newUploadedFiles.length <= 0) {
      return;
    }

    if (this.newUserRequests != null) {
      this.newUploadedFiles.forEach(obj => {
        obj.documentTypeId = 3;
        obj.tempConfigId = Math.random();
      });

      this.newUploadedFiles?.forEach(obj => {
        obj.applyToStates = Object.keys(this.newUserRequests?.reduce((r,{state}) => (r[state]='', r) , {})).join(',');
        // obj.applyToStates = this.newUserRequests.map(item => item.state).join(',');
      });

      this.activeModal.close(this.newUploadedFiles);
    }
    else {

      for (let i = 0; i < this.newUploadedFiles.length; i++) {
        let file = this.newUploadedFiles[i].file;

        if (this.newUploadedFiles[i].selectedStates == null || this.newUploadedFiles[i].selectedStates?.length == 0) {
          this.newUploadedFiles[i].errorMessagesState = "At least one state is required.";
        } else {
          this.newUploadedFiles[i].errorMessagesState = null;
        }
      }

      const invalidTenantFiles = this.newUploadedFiles.filter(file =>
        file.documentTypeId == undefined || file.documentTypeId == null || !file.selectedStates || file.selectedStates.length === 0);

      if (invalidTenantFiles.length > 0) {
        return;
      }

      this.newUploadedFiles.forEach(obj => {
        obj.applyToStates = obj.selectedStates.map(item => item.stateCode).join(',');
      });

      this.onboardingService.insertTenantFileConfig(this.newUploadedFiles).subscribe(response => {
        this.activeModal.close(true);
      })
    }
  }

  clearStateError(file) {
    file.errorMessagesState = null;
  }

  insertUserFile() {

    this.ss.showLoader();
    if (this.newUploadedFiles.length <= 0) {
      return;
    }


    this.newUploadedFiles.forEach(obj => {
      obj.applyToStates = this.onboardingUser.state;
      obj.documentTypeId = 3;
    });

    var userFiles: UserFile[] = [] as UserFile[];
    this.newUploadedFiles.forEach(obj => {
      userFiles.push({
        documentName: obj.file.name,
        state: this.onboardingUser.state,
        documentTypeId: 3,
        userId: this.onboardingUser.userId,
        file: obj.file,
        memo: obj.memo,
        userFileId:this.checkList.userFileId
      } as UserFile);
    });

  this.onboardingService.uploadUserFile(userFiles).subscribe({
      next: (response) => {
        this.ss.hideLoader();
        this.activeModal.close(true);
      },
      error: (error) => {
        this.ss.hideLoader();
        console.error(error);
        // Show error message if needed
        // this.ss.showError('File upload failed.');
      }
  });
  }


}
